export default __webpack_public_path__ + "static/6_20-94e82c7da539c4cc2b785d028328d4c8.png";